import { NgModule } from '@angular/core';

import { SharedModule }                 from '../../app-lite/shared/shared.module';
import { TableModule }                  from '../table/table.module';
import { VendorActionsComponent }       from './vendor.actions.component';
import { VendorActivityLogsComponent }  from './vendor.activity-logs.component';
import { VendorQuickAddComponent }      from './vendor.quick-add.component';
import { VendorSearchControlComponent } from './vendor.search-control.component';
import { VendorSearchService }          from './vendor.search.service';

@NgModule({
  declarations: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorQuickAddComponent,
    VendorSearchControlComponent
  ],
  entryComponents: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorQuickAddComponent,
    VendorSearchControlComponent
  ],
  exports: [
    VendorSearchControlComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    VendorSearchService
  ]
})
export class VendorsModule {}